import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HdmuiCloudToolbarModule } from '@heidelberg/hdmui-angular';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SessionAuthGuard } from './core/session/session-auth.guard';
import { AfterLoginComponent } from './login/after-login.component';
import { ProfileDetailComponent } from './login/profile-detail.component';
import { NavigationModule } from './navigation/navigation.module';
import { UiSharedModule } from './ui-shared/ui-shared.module';
import { createTranslateLoader } from './core/locale.support';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    AfterLoginComponent,
    ProfileDetailComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    UiSharedModule,
    HdmuiCloudToolbarModule,
    NavigationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    SessionAuthGuard,
  ]
})
export class AppModule { }
